import { render, staticRenderFns } from "./FilterOrder.vue?vue&type=template&id=e8db8888"
import script from "./FilterOrder.vue?vue&type=script&lang=ts"
export * from "./FilterOrder.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/Untitled/project/185/185admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e8db8888')) {
      api.createRecord('e8db8888', component.options)
    } else {
      api.reload('e8db8888', component.options)
    }
    module.hot.accept("./FilterOrder.vue?vue&type=template&id=e8db8888", function () {
      api.rerender('e8db8888', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/give-away/components/FilterOrder.vue"
export default component.exports